export enum BusinessModule {
    AdminTenant = 'AdminTenant',
    AdminTenantUser = 'AdminTenantUser',
    AdminUser = 'AdminUser',
    AiServiceQueueItem = 'AiServiceQueueItem',
    ApplicationUser = 'ApplicationUser',
    Audit = 'Audit',
    AuditEscalationGroup = 'AuditEscalationGroup',
    AuditFaultType = 'AuditFaultType',
    AuditTiming = 'AuditTiming',
    AuditWorkplace = 'AuditWorkplace',
    AuditShiftType = 'AuditShiftType',
    Category = 'Category',
    CategoryUser = 'CategoryUser',
    Codebook = 'Codebook',
    Customer = 'Customer',
    Department = 'Department',
    File = 'File',
    Finding = 'Finding',
    Group = 'Group',
    GroupUser = 'GroupUser',
    Import = 'Import',
    Issue = 'Issue',
    IssueResponse = 'IssueResponse',
    Location = 'Location',
    Measure = 'Measure',
    NULL = '',
    NotRatedOptionReason = 'NotRatedOptionReason',
    Permission = 'Permission',
    PlanItem = 'PlanItem',
    Position = 'Position',
    Product = 'Product',
    Project = 'Project',
    Question = 'Question',
    QuestionGroup = 'QuestionGroup',
    Response = 'Response',
    Role = 'Role',
    Shift = 'Shift',
    ShiftStation = 'ShiftStation',
    ShiftType = 'ShiftType',
    SolvedIssue = 'SolvedIssue',
    Station = 'Station',
    SystemUser = 'SystemUser',
    Tenant = 'Tenant',
    TenantConnection = 'TenantConnection',
    TenantDevice = 'TenantDevice',
    TenantDeviceSubscription = 'TenantDeviceSubscription',
    TenantInvitation = 'TenantInvitation',
    TenantIpRestriction = 'TenantIpRestriction',
    TenantUser = 'TenantUser',
    Unanswered = 'Unanswered',
    UserRole = 'UserRole',
    Verification = 'Verification',
    Workplace = 'Workplace',
    WorkplaceShutdown = 'WorkplaceShutdown',
    Notification = 'Notification',
    PanelDashboard = 'PanelDashboard',
    ScrapReason = 'ScrapReason',
    ScrapReasonWorkplace = 'ScrapReasonWorkplace',
    ShiftScrapRecord = 'ShiftScrapRecord',
    ServiceQueueItem = 'ServiceQueueItem',
}
